
export default {
    name: 'ReadAloudButton',

    props: {
        audioUrl: {
            type: String,
            default: null,
        }
    },

    data() {
        return {
            audio: null,
            isPlaying: false,
            isPaused: false,
            currentTime: 0,
            duration: 0,
        }
    },

    computed: {
        audioProcessing() {
            return this.isPlaying || this.isPaused;
        },
        headphoneIconPath() {
            return this.$vuetify.theme.dark
                ? require('@/assets/icons/head-phone-read-aloud-dark.svg')
                : require('@/assets/icons/head-phone-read-aloud-light.svg')
        },
        formattedRemainTime() {
            const t = Math.max(0, Math.floor((this.duration || 0) - (this.currentTime || 0)));
            const hours = Math.floor(t / 3600);
            const min = Math.floor((t % 3600) / 60).toString().padStart(2, '0');
            const sec = Math.floor(t % 60).toString().padStart(2, '0');

            if (hours > 0) {
                return `${hours}:${min}:${sec}`;
            }

            return `${min}:${sec}`;
        }
    },

    watch: {
        audioUrl: {
            immediate: true,
            handler(url) {
                this.resetAudioData();
                if (url) {
                    this.audio = new Audio(url);
                    this.audio.addEventListener('timeupdate', this.onTimeUpdate);
                    this.audio.addEventListener('ended', this.onEnded);
                    this.audio.addEventListener('loadedmetadata', this.onLoadedMetadata);
                }
            }
        }
    },

    beforeDestroy() {
        this.resetAudioData();
    },

    methods: {
        handleClick() {
            if (!this.audio) {
                return;
            }

            if (this.isPlaying) {
                this.pauseAudio();
                return;
            }

            if (this.isPaused) {
                this.playAudio();
                return;
            }
            
            // play from the beginning
            this.audio.currentTime = 0;
            this.playAudio();
        },
        playAudio() {
            if (this.audio) {
                this.audio.play()
                    .then(() => {
                        this.isPlaying = true;
                        this.isPaused = false;
                    })
                    .catch(() => {
                        this.$store.commit('snackbar/updateType', 'error');
                        this.$store.commit('snackbar/updateMessage', this.$t('components.readAloudButton.errorPlayingAudio'));
                    });
            }
        },
        pauseAudio() {
            if (this.audio) {
                this.audio.pause();
                this.isPlaying = false;
                this.isPaused = true;
            }
        },
        onTimeUpdate() {
            this.currentTime = this.audio.currentTime;
        },
        onLoadedMetadata() {            
            this.duration = this.audio.duration;
        },
        onEnded() {
            this.isPlaying = false;
            this.isPaused = false;
            this.currentTime = 0;
        },
        resetAudioData() {
            if (this.audio) {
                this.audio.pause();
                this.audio.removeEventListener('timeupdate', this.onTimeUpdate);
                this.audio.removeEventListener('ended', this.onEnded);
                this.audio.removeEventListener('loadedmetadata', this.onLoadedMetadata);
                this.audio = null;
            }
            this.isPlaying = false;
            this.isPaused = false;
            this.currentTime = 0;
            this.duration = 0;
        }
    }
}
